/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 */

import gql from "graphql-tag";

export const DELETE_TEMPLATE_COSTUME_FEATURE = gql`
  mutation DeleteCostumeFeature($filter: UniqCostumeFeatureFilterInput!) {
    deleteCostumeFeature(filter: $filter) {
      id
    }
  }
`;
